module.exports = __webpack_public_path__ + "assets/45fd8bb94c04b44672d8fdaae43753cd.png";